import { ApiPath } from "enums";
import { Get } from "utils";

export const getVipCards = async ({ ...query }) => {
  const res = await Get(`${ApiPath.VIPCard}`, { ...query });
  return res.data;
};
